const ProgressBar = (props) => {
    const {completed} = props;
    const colorNone = "#e6e6e6";
    const colorFirst = "#f77a52";
    if (!completed) {
        return null;
    }
    const containerStyles = {
        width: '100%',
        backgroundColor: colorNone,
        borderRadius: 50,
        padding: 3
    }
    const fillerStyles = {
        minWidth: `16%`,
        maxWidth: `${completed}%`,
        backgroundColor: colorFirst,
        borderRadius: 'inherit',
        textAlign: 'right',
    }

    const labelStyles = {
        padding: 5,
        fontWeight: 'bold'
    }

    return (
        <div style={containerStyles}>
            <div style={fillerStyles}>
                <span style={labelStyles}>{`${completed.toFixed(0)}%`}</span>
            </div>
        </div>
    );
};

export default ProgressBar;